<template>
  <div :class="`${element.compData.type}-theme-${element.compData.styleId}`"
       :style="{...getStyles(element.compData.styles),
       width: element.width + 'px',
       height: element.height + 'px'}"
  >
    <div class="datePicker">
      <!-- 日期、日期周期 -->
      <DatePicker
        :type="element.compData.format === 1 ? 'date' : 'daterange'"
        v-model="element.compData.date"
        @on-change="handleChange"
        :placeholder="element.compData.format === 1 ? element.compData.placeHolder.date : element.compData.placeHolder.dateRange"
      ></DatePicker>
    </div>
  </div>
</template>

<script>
// iview
import {
  DatePicker
} from 'view-design'

export default {
  name: 'compDatePicker',
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: null,
        data: this.plugin,
        event: null
        }
      })
    })
  },
  methods: {
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    },
    handleChange (date) {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'valueChange',
        eventData: {
          value: {
            value: this.element.compData.date,
          },
          data: this.plugin,
          event: null
        }
      })
      // this.element.compData.date = date;
    },
  },
  components: {
    DatePicker
  },
}
</script>

<style lang='less' scoped>
  .datePicker {
    width: 100%;
    height: 100%;
  }
  /deep/ .ivu-date-picker{
    width: 100%;
    .ivu-input {
      height: var(--height);
      font-size: var(--fontSize);
      border: var(--borderWidth) solid var(--borderColor);
      border-radius: var(--borderRadius);
      color: var(--fontColor);
      background-color: var(--backgroundColor);
      font-family: var(--fontFamily);
    }
    .ivu-input-suffix {
      display: flex;
      align-items: center;
      .ivu-icon {
        font-size: 28px;
      }
    }
    .ivu-input-with-suffix {
      padding-left: var(--padding);
    }
    .ivu-select-dropdown {
      background-color: #fff;
      top: var(--height)!important;
    }
    .ivu-date-picker-header {
      border-bottom: 1px solid #eeeeee;
      color: #000;
      font-size: 18px;
    }
    span.ivu-date-picker-cells-cell {
      color: #000;
    }
  }
</style>
